import { Col, Row } from "react-bootstrap";
import { Link } from "react-router";

export default function CategoryPanel25({ content, path }: any) {
    return (
        <Col xs={12} md={6} lg={3}>
            <Row className="rounded-4 m-1 my-2 p-3 shadow border-2 border border-warning warrningGradientYellowToWhiteBottom">
                <Col xs={6} md={12} className="text-center fs-4 fs-xl-6 smallCategoryPanelHeight">
                    <span className="small fw-bold text-dark text-break">{content.categoryName}</span>
                </Col>
                <Col xs={6} md={12} className="text-center py-2 ">
                    <Link to={path} className="btn btn-success btn fw-bold">
                        Zobacz
                        <span className="bi bi-caret-right-fill"></span>
                    </Link>
                </Col>
            </Row>
        </Col>
    )
}